"use client";
import React from "react";
import Image from "next/image";
import { Container } from "reactstrap";
import {
  TwitterShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from "react-share";
import htmlParser from "html-react-parser";

import { ArticleType } from "@/@types/BlogArticle";
import { blogPerson, blogPlaceholder } from "@/utils/images";
import QuickVideosMain from "../quick-videos/quick-videos-main";
import { BsFacebook, BsLinkedin, BsTwitter } from "react-icons/bs";
import { blogArticleContent } from "@/utils/content";
import classes from "@/styles/blog/blog-main.module.css";

type ArticleContentProps = {
  article: ArticleType;
  isBlogPage?: boolean;
  classes: any;
};

const ArticleContent = ({
  article,
  isBlogPage = false,
}: ArticleContentProps) => {
  const {
    title,
    subtitle,
    imagePath,
    date,
    content,
    author,
    authorPhotoPath,
    images,
    youtubeURL,
  } = article;
  const shareUrl = "";
  const blogContent = blogArticleContent.en;

  return (
    <>
      <section className="my-5">
        <div className={` container ${classes.blogDetailsHeader}`}>
          <h3 className="fw-bold my-3">{title}</h3>
          <small>{date}</small>
          <div className="d-flex align-items-center gap-3 my-5">
            <Image
              src={authorPhotoPath ? authorPhotoPath : blogPerson}
              alt="Author"
              width={50}
              height={50}
            />
            <h6>
              {blogContent.writtenBy}: {author}
            </h6>
          </div>
        </div>
      </section>
      <section>
        <Container>
          <Image
            src={imagePath ? imagePath : blogPlaceholder}
            alt={title}
            height={350}
            width={1300}
            style={{ width: "100%", height: "auto" }}
          />
        </Container>
      </section>

      <section className="mb-4">
        <Container className={classes.blogDetailsHeader}>
          {subtitle && <h4 className="mt-4">{subtitle}</h4>}
          {!isBlogPage && <b>{date} - </b>}
          <div className={classes.content}>{htmlParser(content)}</div>
          {youtubeURL && (
            <div className="text-center">
              <a target="_blank" href={youtubeURL}>
                {blogContent.link1}
              </a>
            </div>
          )}
        </Container>
        {images && images?.length > 0 && (
          <>
            <h2 style={{ textAlign: "center" }}>{blogContent.title1}</h2>
          </>
        )}
      </section>
      <section>
        <Container>
          <p className="text-center text-secondary text-uppercase">
            {blogContent.share}
          </p>
          <div className={classes.icoGrid}>
            <TwitterShareButton
              url={shareUrl}
              className={classes.icoWrapper}
              title={`${title} on Shipvista.com`}
            >
              <BsTwitter size={20} className={classes.ico} />
            </TwitterShareButton>

            <FacebookShareButton url={shareUrl} className={classes.icoWrapper}>
              <BsFacebook size={20} className={classes.ico} />
            </FacebookShareButton>

            <LinkedinShareButton
              url={shareUrl}
              className={classes.icoWrapper}
              title={`${title} on Shipvista.com`}
            >
              <BsLinkedin size={20} className={classes.ico} />
            </LinkedinShareButton>
          </div>
        </Container>
      </section>
      <h2 style={{ textAlign: "center" }}>{blogContent.title2}</h2>
      <QuickVideosMain />
    </>
  );
};

export default ArticleContent;
